import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { AdminLogin, AdminMain, Login, Main } from 'components';
import {
  ADMIN_LOGIN_PATH,
  ADMIN_MAIN_PATH,
  LOGIN_PATH,
  MAIN_PATH,
} from 'config';
import { AdminAuthGuard, AuthGuard, GuestGuard } from 'guards';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path={LOGIN_PATH}
        element={
          <GuestGuard path={MAIN_PATH}>
            <Login />
          </GuestGuard>
        }
      />
      <Route
        path={MAIN_PATH}
        element={
          <AuthGuard>
            <Main />
          </AuthGuard>
        }
      />
      <Route
        path={ADMIN_LOGIN_PATH}
        element={
          <GuestGuard path={ADMIN_MAIN_PATH}>
            <AdminLogin />
          </GuestGuard>
        }
      />
      <Route
        path={ADMIN_MAIN_PATH}
        element={
          <AdminAuthGuard>
            <AdminMain />
          </AdminAuthGuard>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
